const { Helmet } = require('react-helmet');

const CustomMetaTags = ({
  title = 'Salestable',
  description = 'AI-Powered SAAS platform to bring Coaches, Community, Processes together for 10x growth',
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
    </Helmet>
  );
};

export default CustomMetaTags;
